import { Mapper } from 'src/base/mapper'
import { SubscriptionItemTypeEntity } from 'src/data/entities/subscription.entity'
import { SubscriptionItemTypeModel } from 'src/domain/models/subscription.model'

export class SubscriptionItemMapper extends Mapper<SubscriptionItemTypeEntity, SubscriptionItemTypeModel> {
	mapFrom(param: SubscriptionItemTypeEntity): SubscriptionItemTypeModel {
		return this.resultData(param)
	}

	mapTo(param: SubscriptionItemTypeModel): SubscriptionItemTypeEntity {
		return this.resultData(param)
	}

	resultData(param: SubscriptionItemTypeEntity | SubscriptionItemTypeModel) {
		return {
			subscriptionId: param.subscriptionId,
			subscriptionItemId: param.subscriptionItemId,
			itemNumber: param.itemNumber,
			planId: param.planId,
			qty: param.qty,
			discount: param.discount,
			isIncludeVat: param.isIncludeVat,
			vat: param.vat,
			vatAmount: param.vatAmount,
			totalAmount: param.totalAmount,
			unitPrice: param.unitPrice,
			pricePerSeat: param.pricePerSeat,
			minimumPrice: param.minimumPrice,
			amount: param.amount,
			plan: param.plan,
			isActive: param.isActive,
			isOnetimePaid: param.isOnetimePaid,
			planName: param.planName,
			startQty: param.startQty,
			endQty: param.endQty,
			dateCreated: param.dateCreated,
			diffVatAmount: param.diffVatAmount,
			diffTotalAmount: param.diffTotalAmount,
			discountQty: param.discountQty,
			seq: param.seq,
			invoiceId: param.invoiceId,
			isWaitingDelete: param.isWaitingDelete,
			isUseRealQty: param.isUseRealQty,
			addOns: param.addOns,
			dateExpire: param.dateExpire,
			parentId: param.parentId,
			isDowngrade: param.isDowngrade,
			couponId: param.couponId,
		}
	}
}
